// src/components/atoms/Checkbox/Checkbox.tsx
import React, { ChangeEvent, useEffect, useRef } from 'react'
import { checkbox, checkmark, wrapper, label } from './Checkbox.css'

export interface CheckboxProps {
  checked: boolean
  onChange: (v: boolean) => void
  indeterminate?: boolean
  disabled?: boolean
  size?: 'small' | 'medium' | 'large'
  showIcon?: boolean
  label?: string
}

export const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  onChange,
  indeterminate = false,
  disabled = false,
  size = 'medium',
  showIcon = false,
  label: text,
}) => {
  const ref = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (ref.current) ref.current.indeterminate = indeterminate
  }, [indeterminate])

  const state = indeterminate ? 'indeterminate' : checked ? 'checked' : 'unchecked'

  return (
    <label className={wrapper} style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}>
      <input
        ref={ref}
        type="checkbox"
        className={checkbox}
        checked={checked}
        disabled={disabled}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.checked)}
      />
      <span
        className={checkmark({ size, state, showIcon, disabled })}
      />
      {text && <span className={`text-sm ${label}`}>{text}</span>}
    </label>
  )
}